/**
 * Geometry tokens for the static mirrored knockout bracket (FotMob-style: compact two-team boxes
 * joined by elbow connectors, both halves of the draw meeting at the Final). Colours live in the
 * theme-driven `.styles.ts` files; these are pure layout numbers.
 */

/** Compact match box. */
export const BRACKET_BOX_W = 112
export const BRACKET_BOX_MIN_H = 62
/** Crest pixel size inside a team cell. */
export const BRACKET_CREST_SIZE = 22
/** Vertical gap between sibling boxes in a round column (drives connector height). */
export const BRACKET_BOX_GAP = 16
/** Cross-axis slot height reserved per box in the densest (outer) round; sets the track height. */
export const BRACKET_BOX_SLOT = 86
/** Floor for the track height so the centre stack (trophy + Final + bronze) never clips on a
 *  shallow bracket (e.g. a QF-only cup). Must exceed trophy + Final + bronze + their gaps. */
export const BRACKET_MIN_TRACK_H = 332
/** Horizontal gap a connector spans between two round columns. This is the minimum; on wide
 *  screens the gap grows (up to the max) so the bracket fills the container edge-to-edge. */
export const BRACKET_CONNECTOR_W = 22
export const BRACKET_CONNECTOR_W_MAX = 220
/** Horizontal padding inside the bracket scroll area (kept in sync with the tree content style). */
export const BRACKET_TREE_PADDING_X = 8

/** Connector line weight + corner radius (matches the box radius family). */
export const BRACKET_LINE_W = 1.5
export const BRACKET_CONNECTOR_RADIUS = 10

/** Centre column: trophy illustration size + the reserved Final box height the trophy/bronze
 *  are positioned around (so all three stack around the cross-axis centre). */
export const BRACKET_TROPHY_SIZE = 64
export const BRACKET_CENTER_FINAL_H = 96
export const BRACKET_TROPHY_GAP = 18
export const BRACKET_BRONZE_GAP = 22
